enum TicketFilters {
    Ticket = "Ticket",
    Customer = "Customer",
    Machine = "Machine",
    Country = "Country",
    Assignee = "Assignee",
    Status = "Status",
    Jobsite = "Jobsite",
    Category = "Category",
    Title = "Title"
}

export default TicketFilters;